var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},_vm._l((_vm.data),function(item,index){return _c('el-row',{key:index},[_c('company-mail-item',_vm._g({model:{value:(_vm.dataCopy[index]),callback:function ($$v) {_vm.$set(_vm.dataCopy, index, $$v)},expression:"dataCopy[index]"}},_vm.$listeners))],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }